export const getTimeDuration = (startTime, endTime) => {
    const duration = endTime.getTime() - startTime.getTime();

    return convertMiliSeconedToHourAndMinute(duration);
}

export const convertMiliSeconedToHourAndMinute = (time) => {
    let seconds = Math.floor(time / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;

    return `${formateTime(hours)}:${formateTime(minutes)}:${formateTime(seconds)}`;
}

export const formateTime = (time) => {
    return time.toString().padStart(2, '0');
}

export const getFirstDateOfMonth = (date) => {
    if (!date) {
        date = new Date();
    }

    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export const getNextMonthDate = (date) => {
    // Get the current month and year
    var currentMonth = date.getMonth();
    var currentYear = date.getFullYear();

    // Calculate the month and year for the next month
    var nextMonth = (currentMonth + 1) % 12; // Add 1 and wrap around to 0-11
    var nextYear = currentYear + Math.floor((currentMonth + 1) / 12);

    // Create a new date object for the same day of the next month
    return new Date(nextYear, nextMonth, date.getDate());
}

export const formatTimeToServerFormat = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
}

// Function to get the first day of a specific month
export const getFirstDayOfMonth = (date) => {
    if (!date) {
        date = new Date(); // If no date is provided, use the current date
    }
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

// Function to get the last day of a specific month
export const getLastDayOfMonth = (date) => {
    if (!date) {
        date = new Date(); // If no date is provided, use the current date
    }
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate());
}

export const formatDateString = (dateString) => {
    // Use a regex to split by dot or slash
    const parts = dateString.split(/\.|\//).map(part => parseInt(part, 10));

    let year, month, day;

    if (parts.length === 3) {
        let [part1, part2, part3] = parts;

        // Determine if the last part is the year based on its value
        if (part3 > 31) {
            year = part3;
            if (part1 > 12 && part2 <= 12) {
                day = part1;
                month = part2;
            } else if (part2 > 12 && part1 <= 12) {
                month = part1;
                day = part2;
            } else {
                // Assuming the first part is the month and the second is the day by default
                month = part1;
                day = part2;
            }
        } else {
            // If cannot determine the year correctly, log an error
            console.error('Invalid date format, cannot determine the year correctly.');
            return getTodayDateString();
        }
    } else {
        console.error('Invalid date format');
        return getTodayDateString();
    }

    if (year && month <= 12 && day <= 31) {
        return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    } else {
        console.error('Invalid date parts, defaulting to today\'s date.');
        return getTodayDateString();
    }
}

export const getTodayDateString = () => {
    const today = new Date();
    return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
}